import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c799cba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-nav" }
const _hoisted_2 = { class: "home_contents_wrapper" }

import MylistOrders from '@/components/MylistOrders.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'MylistView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MylistOrders)
    ])
  ]))
}
}

})